import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import KiranaReceipt from "views/app-views/info/PolicyDetails/kiranaReceipt";
import html2pdf from "html2pdf.js";
import DebouncedButton from "components/DebouncedButton/DebouncedButton";
import {
    EditOutlined,
    DownloadOutlined,
    FilePdfOutlined,
    SearchOutlined,
    FilterOutlined,
    ExportOutlined,
} from "@ant-design/icons";
import { TEMPLATE_ALPA_BIMA_COMPARE, TEMPLATE_CIT_COMPARE, TEMPLATE_SME_KIRANA_COMPARE } from "constants/TemplateCodes";
import ReceiptFormate from "../info/PolicyDetails/ReceiptFormate";
import service from "auth/FetchInterceptor";
import { API_ENDPOINTS } from "constants/ApiEndpoint";

const PaymentDetails = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const {policy_id,order_id} = useParams();
    const [data_policy,setData] = useState({});
    const  getPolicyDetails = async()=>{
        const res = await service({
            method: "GET",
            url: `${API_ENDPOINTS.GET_POLICY}${policy_id}`,
        });
        const tableData = res.data[0];
        setData(tableData);
    }
//     useEffect(() => {
//     const alreadyRedirected = searchParams.get("redirected");

//     if (!alreadyRedirected) {
//             localStorage.setItem(("payment_redirect_data"), JSON.stringify({ policy_id, order_id }));
//             setTimeout(() => {
//         window.close();
//       }, 1000);
//     } else{
//     }
//   }, [navigate, policy_id, order_id, searchParams]);

//   // ✅ Step 2: Intercept back button only AFTER redirect
//   useEffect(() => {
//     const alreadyRedirected = searchParams.get("redirected");

//     if (alreadyRedirected) {
//       // Trap back
//       window.history.pushState(null, "", window.location.href);

//       const handlePopState = () => {
//                 // alert('pop state trigerred');
//         window.location.replace("/app/info/PolicyDetails");
//       };

//       window.addEventListener("popstate", handlePopState);

//       return () => {
//         window.removeEventListener("popstate", handlePopState);
//       };
//     }
//   }, [searchParams]);
    useEffect(()=>{
        getPolicyDetails();
    },[])

    useLayoutEffect(()=>{
        const input = document.getElementById("test");
        if(input){
            input.focus();
            // let test = window.confirm("Do you wish to go to reports?");
            // if(test){
            // 	navigate("/app/info/PolicyDetails");
            // } else{

            // }
        }
    },[data_policy])

    const location = useLocation();
    // const { policyData, paymentData } = location.state || {};

    const receiptRef = useRef(null);
    let receiptData={};

    if(Object.keys(data_policy).length>0){
        receiptData ={
        certificate_no: data_policy?.certificate_no || "",
        default_policy_no: data_policy?.default_policy_no || "",
        gender: data_policy?.gender || "",
        gross_premium: data_policy?.gross_premium || 0,
        gst: data_policy?.gst || 0,
        premium_amount: data_policy?.premium_amount || 0,

        customer_id: data_policy.customer_id,
        package_name: data_policy.package_name,
        policy_date: data_policy?.policy_date?.split("T")[0] || "",
        name : data_policy.name,
        created_at : new Date(data_policy.created_at).toISOString().split("T")[0],
        txn_amount : data_policy.txn_amount / 100,
        txn_id : data_policy.txn_id,
        email : data_policy.email ,
        mobile : data_policy.mobile ,
    }
    }
    const downloadReceipt = async (uniqueId) => {
        const element = receiptRef.current;
        if (!element) return;
        const opt = {
            margin: 0.1,
            filename: `${uniqueId}_Receipt`,
            image: { type: "jpeg", quality: 1 },
            html2canvas: { scale: 4 },
            jsPDF: { unit: "in", format: [9, 16], orientation: "portrait" },
        };
        html2pdf().from(element).set(opt).save();
        // const canvas = await html2canvas(element);
        // const imgData = canvas.toDataURL("image/png");
        // const pdf = new jsPDF();
        // pdf.addImage(imgData, "PNG", 10, 10, 180, 0);
        // pdf.save("receipt.pdf");
    };


    if(Object.keys(data_policy).length == 0){
        return (
  <div
    style={{
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontSize: "20px",
      // fontWeight: "bold",
      color: "#555",
    }}
  >
    Loading...
  </div>
);
    }

if (Object.keys(data_policy).length > 0 && data_policy?.policy_status?.toLowerCase() !== "success") {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100vh",
                backgroundColor: "#fff0f0",
                color: "#d32f2f",
                textAlign: "center",
                padding: "20px",
            }}
        >
            <input type="text" style={{display:"none"}} id="test" />
            {/* <div style={{ fontSize: "80px" }}>❌</div> */}
            <h1 style={{ marginBottom: "10px" }}>Payment status {data_policy?.policy_status}</h1>
            <p style={{ fontSize: "16px", maxWidth: "500px" }}>
                We were unable to process your payment.
            </p>
            <div style={{ marginTop: "20px" }}>
                <DebouncedButton
                    onClick={() => {
                        localStorage.removeItem('payment-retry');
                        navigate("/app/info/PolicyDetails")
                    }}
                    style={{
                        backgroundColor: "#d32f2f",
                        color: "#fff",
                        padding: "10px 20px",
                        border: "none",
                        borderRadius: "4px",
                        fontWeight: "bold",
                    }}
                >
                    Go Back to Reports
                </DebouncedButton>
                {
                    localStorage.getItem('payment-retry') &&
                    <DebouncedButton
                        onClick={() => navigate("/app/info/Policy?retry-payment=true")}
                        style={{
                            backgroundColor: "#d32f2f",
                            color: "#fff",
                            padding: "10px 20px",
                            border: "none",
                            borderRadius: "4px",
                            fontWeight: "bold",
                            marginLeft:'2px'
                        }}
                    >
                        Retry Payment
                    </DebouncedButton>
                }

            </div>
        </div>
    );
}

    return (
        <div>
            <input type="text" style={{display:"none"}} id="test" />
            <h2>Payment Successful</h2>

            <div ref={receiptRef} style={{ padding: "20px", border: "1px solid #ccc" }}>
                {
                    (data_policy?.template_code?.startsWith(TEMPLATE_CIT_COMPARE) || data_policy?.template_code?.startsWith(TEMPLATE_SME_KIRANA_COMPARE)) ?
                        <KiranaReceipt getTableData={receiptData}
                            getpackageID={data_policy.package_name}
                        />
                        :
                        <ReceiptFormate getTableData={receiptData}
                            getpackageID={data_policy.package_name}
                        />
                }
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "0px", marginTop: "10px" }}>
                <div style={{ width: 120 }}>
                    <DebouncedButton
                        className="button-receipt text-dark"
                        onClick={async () => {
                            try {
                                downloadReceipt(data_policy.policy_no);
                            } catch (error) {
                                console.error("Error in downloading the certificate:", error);
                            }
                        }}
                    >
                        <DownloadOutlined />
                        Receipt
                    </DebouncedButton>
                </div>
                <div style={{ width: 120 }}>
                    <DebouncedButton
                        className="button-receipt text-dark"
                        style={{
                            backgroundColor: "#007bff",
                            color: "white",
                            border: "none",
                        }}
                        onClick={() => navigate("/app/info/PolicyDetails")}
                    >
                        Go to Reports
                    </DebouncedButton>
                </div>
                
            </div>
        </div>
    );
};

export default PaymentDetails;
